var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagramGray = function SvgInstagramGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12858"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "none",
    "data-name": "Oval Copy 2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1780"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "none",
    "data-name": "Ellipse 47"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1778"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7b838f",
    d: "M18.944 8.613h-6.887a3.453 3.453 0 0 0-3.444 3.444v6.887a3.454 3.454 0 0 0 3.444 3.444h6.887a3.454 3.454 0 0 0 3.444-3.444v-6.887a3.453 3.453 0 0 0-3.444-3.444M15.5 18.37a2.87 2.87 0 1 1 2.87-2.87 2.87 2.87 0 0 1-2.87 2.87m3.731-5.739a.861.861 0 1 1 .861-.861.861.861 0 0 1-.861.86Z",
    "data-name": "Path 2163"
  }))))));
};
export default SvgInstagramGray;